import React from 'react';
import { RouteProps } from 'react-router-dom';
import { loginPagesMenu, unloggedPages } from '../menu';
import DefaultFooter from '../pages/_layout/_footers/DefaultFooter';

const footers: RouteProps[] = [
	{ path: loginPagesMenu.login.path, element: null },
	{ path: unloggedPages.page404.path, element: null },
	{ path: '*', element: <DefaultFooter /> },
];

export default footers;
